module.exports = __webpack_public_path__ + "static/media/S (15).0d92e00a.jpg";